<template>
  <div 
    v-if="shouldShow" 
    class="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 shadow-lg"
  >
    <div class="max-w-7xl mx-auto flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <svg class="w-6 h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
        </svg>
        <div>
          <h4 class="font-medium">¿Quieres recibir notificaciones?</h4>
          <p class="text-sm opacity-90">
            Te avisaremos cuando haya nuevas propiedades que te puedan interesar
          </p>
        </div>
      </div>
      
      <div class="flex items-center space-x-2">
        <button
          @click="enableNotifications"
          :disabled="loading"
          class="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition-colors disabled:opacity-50"
        >
          <span v-if="loading" class="inline-block w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mr-2"></span>
          {{ loading ? 'Habilitando...' : 'Habilitar' }}
        </button>
        <button
          @click="dismiss"
          class="text-white/80 hover:text-white p-2 rounded-lg hover:bg-white/10 transition-colors"
        >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { notificationManager } from '@/utils/notifications';

export default {
  name: 'NotificationBanner',
  data() {
    return {
      loading: false,
      dismissed: false
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated'
    }),
    
    shouldShow() {
      // Solo mostrar si:
      // 1. El usuario está autenticado
      // 2. Las notificaciones son soportadas
      // 3. No están ya habilitadas
      // 4. No ha sido descartado
      // 5. No se ha descartado permanentemente
      return (
        this.isAuthenticated &&
        notificationManager.isSupported &&
        !notificationManager.isEnabled() &&
        !this.dismissed &&
        !this.isDismissedPermanently()
      );
    }
  },
  methods: {
    async enableNotifications() {
      this.loading = true;
      
      try {
        await notificationManager.enableNotifications();
        this.dismissed = true;
        
        // Mostrar mensaje de éxito
        this.$emit('notification-enabled');
      } catch (error) {
        console.error('Error enabling notifications:', error);
        
        // Mostrar error al usuario
        this.$emit('notification-error', error.message);
      } finally {
        this.loading = false;
      }
    },
    
    dismiss() {
      this.dismissed = true;
      
      // Recordar que fue descartado por esta sesión
      sessionStorage.setItem('notification_banner_dismissed', 'true');
    },
    
    dismissPermanently() {
      this.dismissed = true;
      
      // Recordar que fue descartado permanentemente
      localStorage.setItem('notification_banner_dismissed_permanently', 'true');
    },
    
    isDismissedPermanently() {
      return localStorage.getItem('notification_banner_dismissed_permanently') === 'true';
    },
    
    isDismissedThisSession() {
      return sessionStorage.getItem('notification_banner_dismissed') === 'true';
    }
  },
  
  mounted() {
    // Si ya fue descartado en esta sesión, no mostrar
    if (this.isDismissedThisSession()) {
      this.dismissed = true;
    }
  }
};
</script>

<style scoped>
/* Asegurar que el banner esté encima de todo */
.z-50 {
  z-index: 50;
}
</style>
